module.exports = __webpack_public_path__ + "static/media/f9.cec659f0.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/Feather/f9.png
// module id = 1220
// module chunks = 0